import useClassNames from '@medflex/hooks/useClassNames';
import React, { useContext } from 'react';
import TooltipContext from './TooltipContext';

const TooltipArrow = () => {
  const { arrow, placement } = useContext(TooltipContext);
  const cn = useClassNames(
    () => [
      'absolute',
      'w-3',
      'h-3',
      'transform',
      'rotate-45',
      'bg-slate-800',
      placement.indexOf('top') !== -1 && '-mb-1',
      placement.indexOf('top') !== -1 && 'bottom-0',
      placement.indexOf('right') !== -1 && '-ml-1',
      placement.indexOf('right') !== -1 && 'left-0',
      placement.indexOf('bottom') !== -1 && '-mt-1',
      placement.indexOf('bottom') !== -1 && 'top-0',
      placement.indexOf('left') !== -1 && '-mr-1',
      placement.indexOf('left') !== -1 && 'right-0',
    ],
    [placement],
  );
  return <div data-component="TooltipArrow" {...arrow} className={cn} />;
};

export default TooltipArrow;
